export const resources = [
  {
    "Ressource name": "BabyPips",
    "Type": "Website",
    "Why it's useful": "The ultimate starting point for beginners. Offers a comprehensive, easy-to-understand 'School of Pipsology' that breaks down complex forex concepts into digestible lessons.",
    "Link": "https://www.babypips.com/learn/forex",
    "Image": "/assets/Babypips-logo.png"
  },
  {
    "Ressource name": "Volatility.RED",
    "Type": "Website",
    "Why it's useful": "An unfiltered look into the realities of forex trading. Cuts through the noise to provide genuine insights on market volatility, risk management, and trading psychology.",
    "Link": "https://volatility.red/Main_Page",
    "Image": "/assets/volatilityred-logo.png"
  },
  {
    "Ressource name": "Trading180",
    "Type": "Youtube Channel",
    "Why it's useful": "Exceptional video content focusing on trading fundamentals rather than get-rich-quick schemes. Perfect for building a solid foundation in technical and fundamental analysis.",
    "Link": "https://www.youtube.com/@Trading180",
    "Image": "/assets/Trading180-logo.jpg"
  },
  {
    "Ressource name": "ImanTrading",
    "Type": "Youtube Channel",
    "Why it's useful": "A must-watch channel for navigating the trading industry safely. Exposes common scams, reviews courses honestly, and promotes realistic trading expectations.",
    "Link": "https://www.youtube.com/@ImanTrading",
    "Image": "/assets/imantrading-logo.jpg"
  },
  {
    "Ressource name": "Trading in the Zone",
    "Type": "Book",
    "Why it's useful": "A masterpiece by Mark Douglas on trading psychology. It fundamentally shifts how you perceive market probabilities and helps eliminate emotional decision-making.",
    "Link": "https://amzn.to/3OmV5eX",
    "Image": "/assets/tradinginthezone-logo.jpg"
  },
  {
    "Ressource name": "Reminiscences of a Stock Operator",
    "Type": "Book",
    "Why it's useful": "A timeless classic detailing the life of Jesse Livermore. Offers profound lessons on market behavior, crowd psychology, and the harsh realities of speculation.",
    "Link": "https://amzn.to/41Vexm5",
    "Image": "/assets/reminiscencesofastockoperator-logo.jpg"
  },
  {
    "Ressource name": "Economics for Dummies, 3rd Edition",
    "Type": "Book",
    "Why it's useful": "An accessible guide to macroeconomic principles. Essential for understanding how interest rates, inflation, and central bank policies drive currency valuations.",
    "Link": "https://amzn.to/4tBexDW",
    "Image": "/assets/economicsfordummies-logo.jpg"
  },
  {
    "Ressource name": "TradingView",
    "Type": "Tool",
    "Why it's useful": "The industry standard for charting and technical analysis. Features an intuitive interface, powerful custom indicators, and a vibrant community of traders.",
    "Link": "https://www.tradingview.com/?aff_id=165945",
    "Image": "/assets/tradingview-logo.png"
  },
  {
    "Ressource name": "Trading System Blueprint",
    "Type": "Coming Soon",
    "Why it's useful": "A complete guide on how to build, backtest, and execute a mechanical trading system from scratch. Currently in development.",
    "Link": "#",
    "Image": null
  }
];
